import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useEffectOnce } from 'react-use'
import usePageTitle from '../util/usePageTitle'
import PageContainer from '../components/layout/PageContainer'
import { useViewContent } from '../util/tracking'
import { useRouteError } from 'react-router-dom'
import log from '../util/logging'

interface ErrorPageProps {
  error?: Error
}

const ErrorPage = ({ error }: ErrorPageProps) => {
  useViewContent('Error')
  usePageTitle('Error')

  // Use error from error boundary props, fallback to router error
  const routeError = useRouteError()
  const displayError = error ?? routeError

  useEffectOnce(() => {
    log.error('ErrorPage', displayError)
  })

  return (
    <PageContainer>
      <Box sx={{ mt: 4, p: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom textAlign="center">
          Error occurred
        </Typography>
        <Typography variant="body1" gutterBottom textAlign="center">
          Sorry, it looks like an error occurred with the application
        </Typography>
        <Typography variant="body1" gutterBottom textAlign="center">
          <Link href="/">Go to the home page</Link>
        </Typography>
      </Box>
    </PageContainer>
  )
}

export default ErrorPage
